module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-italic-d8bcbe724fd6f4ba44d0ee6a2675890f.woff2";